/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The ReferredPatientsReferredPatient model module.
 * @module model/ReferredPatientsReferredPatient
 * @version v0.3
 */
export default class ReferredPatientsReferredPatient {
  /**
   * Constructs a new <code>ReferredPatientsReferredPatient</code>.
   * @alias module:model/ReferredPatientsReferredPatient
   * @class
   * @param dateOfBirth {Date} yyyy-mm-dd (ISO 8601)
   * @param emailAddress {String}
   */
  constructor(dateOfBirth, emailAddress) {
    this.dateOfBirth = dateOfBirth;
    this.emailAddress = emailAddress;
  }

  /**
   * Constructs a <code>ReferredPatientsReferredPatient</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReferredPatientsReferredPatient} obj Optional instance to populate.
   * @return {module:model/ReferredPatientsReferredPatient} The populated <code>ReferredPatientsReferredPatient</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ReferredPatientsReferredPatient();
      if (data.hasOwnProperty('epic_mrn'))
        obj.epicMrn = ApiClient.convertToType(data['epic_mrn'], 'String');
      if (data.hasOwnProperty('patient_number'))
        obj.patientNumber = ApiClient.convertToType(data['patient_number'], 'String');
      if (data.hasOwnProperty('health_system'))
        obj.healthSystem = ApiClient.convertToType(data['health_system'], 'String');
      if (data.hasOwnProperty('hospital'))
        obj.hospital = ApiClient.convertToType(data['hospital'], 'String');
      if (data.hasOwnProperty('nih_grant_patient'))
        obj.nihGrantPatient = ApiClient.convertToType(data['nih_grant_patient'], 'Boolean');
      if (data.hasOwnProperty('patient_last_name'))
        obj.patientLastName = ApiClient.convertToType(data['patient_last_name'], 'String');
      if (data.hasOwnProperty('patient_first_name'))
        obj.patientFirstName = ApiClient.convertToType(data['patient_first_name'], 'String');
      if (data.hasOwnProperty('preferred_name'))
        obj.preferredName = ApiClient.convertToType(data['preferred_name'], 'String');
      if (data.hasOwnProperty('date_of_birth'))
        obj.dateOfBirth = ApiClient.convertToType(data['date_of_birth'], 'Date');
      if (data.hasOwnProperty('outreach_assignee'))
        obj.outreachAssignee = ApiClient.convertToType(data['outreach_assignee'], 'String');
      if (data.hasOwnProperty('hc_engagement_status'))
        obj.hcEngagementStatus = ApiClient.convertToType(data['hc_engagement_status'], 'String');
      if (data.hasOwnProperty('patient_status'))
        obj.patientStatus = ApiClient.convertToType(data['patient_status'], 'String');
      if (data.hasOwnProperty('engagement_status'))
        obj.engagementStatus = ApiClient.convertToType(data['engagement_status'], 'String');
      if (data.hasOwnProperty('communications'))
        obj.communications = ApiClient.convertToType(data['communications'], 'String');
      if (data.hasOwnProperty('opt_out_cancelled'))
        obj.optOutCancelled = ApiClient.convertToType(data['opt_out_cancelled'], 'String');
      if (data.hasOwnProperty('opt_in_sms'))
        obj.optInSms = ApiClient.convertToType(data['opt_in_sms'], 'Boolean');
      if (data.hasOwnProperty('opt_in_email'))
        obj.optInEmail = ApiClient.convertToType(data['opt_in_email'], 'Boolean');
      if (data.hasOwnProperty('referral_date'))
        obj.referralDate = ApiClient.convertToType(data['referral_date'], 'Date');
      if (data.hasOwnProperty('enrolled_date'))
        obj.enrolledDate = ApiClient.convertToType(data['enrolled_date'], 'String');
      if (data.hasOwnProperty('surgery_date'))
        obj.surgeryDate = ApiClient.convertToType(data['surgery_date'], 'Date');
      if (data.hasOwnProperty('surgery_time'))
        obj.surgeryTime = ApiClient.convertToType(data['surgery_time'], 'String');
      if (data.hasOwnProperty('surgery_status'))
        obj.surgeryStatus = ApiClient.convertToType(data['surgery_status'], 'String');
      if (data.hasOwnProperty('visit_type'))
        obj.visitType = ApiClient.convertToType(data['visit_type'], 'String');
      if (data.hasOwnProperty('program'))
        obj.program = ApiClient.convertToType(data['program'], 'String');
      if (data.hasOwnProperty('service_line'))
        obj.serviceLine = ApiClient.convertToType(data['service_line'], 'String');
      if (data.hasOwnProperty('surgery_type'))
        obj.surgeryType = ApiClient.convertToType(data['surgery_type'], 'String');
      if (data.hasOwnProperty('surgeon'))
        obj.surgeon = ApiClient.convertToType(data['surgeon'], 'String');
      if (data.hasOwnProperty('main_point_of_contact_at_practice'))
        obj.mainPointOfContactAtPractice = ApiClient.convertToType(data['main_point_of_contact_at_practice'], 'String');
      if (data.hasOwnProperty('email_address'))
        obj.emailAddress = ApiClient.convertToType(data['email_address'], 'String');
      if (data.hasOwnProperty('mobile_phone_number'))
        obj.mobilePhoneNumber = ApiClient.convertToType(data['mobile_phone_number'], 'String');
      if (data.hasOwnProperty('home_phone_number'))
        obj.homePhoneNumber = ApiClient.convertToType(data['home_phone_number'], 'String');
      if (data.hasOwnProperty('pcp_physician'))
        obj.pcpPhysician = ApiClient.convertToType(data['pcp_physician'], 'String');
      if (data.hasOwnProperty('patient_notes'))
        obj.patientNotes = ApiClient.convertToType(data['patient_notes'], 'String');
      if (data.hasOwnProperty('referral_month'))
        obj.referralMonth = ApiClient.convertToType(data['referral_month'], 'String');
      if (data.hasOwnProperty('surgery_month'))
        obj.surgeryMonth = ApiClient.convertToType(data['surgery_month'], 'String');
      if (data.hasOwnProperty('week_of_referral'))
        obj.weekOfReferral = ApiClient.convertToType(data['week_of_referral'], 'String');
      if (data.hasOwnProperty('enrollment_lag'))
        obj.enrollmentLag = ApiClient.convertToType(data['enrollment_lag'], 'Number');
      if (data.hasOwnProperty('enrollment_week'))
        obj.enrollmentWeek = ApiClient.convertToType(data['enrollment_week'], 'String');
      if (data.hasOwnProperty('lead_time'))
        obj.leadTime = ApiClient.convertToType(data['lead_time'], 'Number');
      if (data.hasOwnProperty('enrollment_flag'))
        obj.enrollmentFlag = ApiClient.convertToType(data['enrollment_flag'], 'Boolean');
      if (data.hasOwnProperty('gender_identity'))
        obj.genderIdentity = ApiClient.convertToType(data['gender_identity'], 'String');
      if (data.hasOwnProperty('race'))
        obj.race = ApiClient.convertToType(data['race'], 'String');
      if (data.hasOwnProperty('emergency_contact'))
        obj.emergencyContact = ApiClient.convertToType(data['emergency_contact'], 'String');
      if (data.hasOwnProperty('emergency_contact_phone_number'))
        obj.emergencyContactPhoneNumber = ApiClient.convertToType(data['emergency_contact_phone_number'], 'String');
      if (data.hasOwnProperty('health_system_contact'))
        obj.healthSystemContact = ApiClient.convertToType(data['health_system_contact'], 'String');
      if (data.hasOwnProperty('deceased'))
        obj.deceased = ApiClient.convertToType(data['deceased'], 'Boolean');
      if (data.hasOwnProperty('cancellation_reason'))
        obj.cancellationReason = ApiClient.convertToType(data['cancellation_reason'], 'String');
      if (data.hasOwnProperty('clearances'))
        obj.clearances = ApiClient.convertToType(data['clearances'], ['String']);
      if (data.hasOwnProperty('comorbidities'))
        obj.comorbidities = ApiClient.convertToType(data['comorbidities'], ['String']);
      if (data.hasOwnProperty('smoking'))
        obj.smoking = ApiClient.convertToType(data['smoking'], 'Boolean');
      if (data.hasOwnProperty('diabetes'))
        obj.diabetes = ApiClient.convertToType(data['diabetes'], 'Boolean');
      if (data.hasOwnProperty('hypertension'))
        obj.hypertension = ApiClient.convertToType(data['hypertension'], 'Boolean');
      if (data.hasOwnProperty('anemia'))
        obj.anemia = ApiClient.convertToType(data['anemia'], 'Boolean');
    }
    return obj;
  }
}

/**
 * Patient epic mrn from patient tracker sheet
 * @member {String} epicMrn
 */
ReferredPatientsReferredPatient.prototype.epicMrn = undefined;

/**
 * Patient number from patient tracker sheet
 * @member {String} patientNumber
 */
ReferredPatientsReferredPatient.prototype.patientNumber = undefined;

/**
 * @member {String} healthSystem
 */
ReferredPatientsReferredPatient.prototype.healthSystem = undefined;

/**
 * @member {String} hospital
 */
ReferredPatientsReferredPatient.prototype.hospital = undefined;

/**
 * @member {Boolean} nihGrantPatient
 */
ReferredPatientsReferredPatient.prototype.nihGrantPatient = undefined;

/**
 * @member {String} patientLastName
 */
ReferredPatientsReferredPatient.prototype.patientLastName = undefined;

/**
 * @member {String} patientFirstName
 */
ReferredPatientsReferredPatient.prototype.patientFirstName = undefined;

/**
 * @member {String} preferredName
 */
ReferredPatientsReferredPatient.prototype.preferredName = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} dateOfBirth
 */
ReferredPatientsReferredPatient.prototype.dateOfBirth = undefined;

/**
 * @member {String} outreachAssignee
 */
ReferredPatientsReferredPatient.prototype.outreachAssignee = undefined;

/**
 * @member {String} hcEngagementStatus
 */
ReferredPatientsReferredPatient.prototype.hcEngagementStatus = undefined;

/**
 * @member {String} patientStatus
 */
ReferredPatientsReferredPatient.prototype.patientStatus = undefined;

/**
 * @member {String} engagementStatus
 */
ReferredPatientsReferredPatient.prototype.engagementStatus = undefined;

/**
 * Allowed values for the <code>communications</code> property.
 * @enum {String}
 * @readonly
 */
ReferredPatientsReferredPatient.CommunicationsEnum = {
  /**
   * value: "All"
   * @const
   */
  all: "All",

  /**
   * value: "SMS"
   * @const
   */
  SMS: "SMS",

  /**
   * value: "Email"
   * @const
   */
  email: "Email",

  /**
   * value: "None"
   * @const
   */
  none: "None"
};
/**
 * Preferred communication channels. Maps to opt_in_sms and opt_in_email.
 * @member {module:model/ReferredPatientsReferredPatient.CommunicationsEnum} communications
 */
ReferredPatientsReferredPatient.prototype.communications = undefined;

/**
 * @member {String} optOutCancelled
 */
ReferredPatientsReferredPatient.prototype.optOutCancelled = undefined;

/**
 * Whether the patient may receive SMS messages.
 * @member {Boolean} optInSms
 */
ReferredPatientsReferredPatient.prototype.optInSms = undefined;

/**
 * Whether the patient may receive email messages.
 * @member {Boolean} optInEmail
 */
ReferredPatientsReferredPatient.prototype.optInEmail = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} referralDate
 */
ReferredPatientsReferredPatient.prototype.referralDate = undefined;

/**
 * @member {String} enrolledDate
 */
ReferredPatientsReferredPatient.prototype.enrolledDate = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} surgeryDate
 */
ReferredPatientsReferredPatient.prototype.surgeryDate = undefined;

/**
 * HH:MM (24-hour), hospital local time
 * @member {String} surgeryTime
 */
ReferredPatientsReferredPatient.prototype.surgeryTime = undefined;

/**
 * @member {String} surgeryStatus
 */
ReferredPatientsReferredPatient.prototype.surgeryStatus = undefined;

/**
 * @member {String} visitType
 */
ReferredPatientsReferredPatient.prototype.visitType = undefined;

/**
 * @member {String} program
 */
ReferredPatientsReferredPatient.prototype.program = undefined;

/**
 * Patient service line from patient tracker sheet
 * @member {String} serviceLine
 */
ReferredPatientsReferredPatient.prototype.serviceLine = undefined;

/**
 * Surgery type from patient tracker sheet
 * @member {String} surgeryType
 */
ReferredPatientsReferredPatient.prototype.surgeryType = undefined;

/**
 * Surgery name from patient tracker sheet
 * @member {String} surgeon
 */
ReferredPatientsReferredPatient.prototype.surgeon = undefined;

/**
 * Main point of contact at practice from patient tracker sheet
 * @member {String} mainPointOfContactAtPractice
 */
ReferredPatientsReferredPatient.prototype.mainPointOfContactAtPractice = undefined;

/**
 * @member {String} emailAddress
 */
ReferredPatientsReferredPatient.prototype.emailAddress = undefined;

/**
 * @member {String} mobilePhoneNumber
 */
ReferredPatientsReferredPatient.prototype.mobilePhoneNumber = undefined;

/**
 * @member {String} homePhoneNumber
 */
ReferredPatientsReferredPatient.prototype.homePhoneNumber = undefined;

/**
 * @member {String} pcpPhysician
 */
ReferredPatientsReferredPatient.prototype.pcpPhysician = undefined;

/**
 * @member {String} patientNotes
 */
ReferredPatientsReferredPatient.prototype.patientNotes = undefined;

/**
 * @member {String} referralMonth
 */
ReferredPatientsReferredPatient.prototype.referralMonth = undefined;

/**
 * @member {String} surgeryMonth
 */
ReferredPatientsReferredPatient.prototype.surgeryMonth = undefined;

/**
 * @member {String} weekOfReferral
 */
ReferredPatientsReferredPatient.prototype.weekOfReferral = undefined;

/**
 * @member {Number} enrollmentLag
 */
ReferredPatientsReferredPatient.prototype.enrollmentLag = undefined;

/**
 * @member {String} enrollmentWeek
 */
ReferredPatientsReferredPatient.prototype.enrollmentWeek = undefined;

/**
 * @member {Number} leadTime
 */
ReferredPatientsReferredPatient.prototype.leadTime = undefined;

/**
 * @member {Boolean} enrollmentFlag
 */
ReferredPatientsReferredPatient.prototype.enrollmentFlag = undefined;

/**
 * Allowed values for the <code>genderIdentity</code> property.
 * @enum {String}
 * @readonly
 */
ReferredPatientsReferredPatient.GenderIdentityEnum = {
  /**
   * value: "female"
   * @const
   */
  female: "female",

  /**
   * value: "male"
   * @const
   */
  male: "male",

  /**
   * value: "non_binary"
   * @const
   */
  nonBinary: "non_binary",

  /**
   * value: "non_disclose"
   * @const
   */
  nonDisclose: "non_disclose",

  /**
   * value: "other"
   * @const
   */
  other: "other",

  /**
   * value: "transgender_female"
   * @const
   */
  transgenderFemale: "transgender_female",

  /**
   * value: "transgender_male"
   * @const
   */
  transgenderMale: "transgender_male",

  /**
   * value: "null"
   * @const
   */
  _null: "null"
};
/**
 * The gender the patient identifies with. The Patient's gender identity is used as guidance(e.g. for staff) about how to interact with the patient.
 * @member {module:model/ReferredPatientsReferredPatient.GenderIdentityEnum} genderIdentity
 */
ReferredPatientsReferredPatient.prototype.genderIdentity = undefined;

/**
 * @member {String} race
 */
ReferredPatientsReferredPatient.prototype.race = undefined;

/**
 * @member {String} emergencyContact
 */
ReferredPatientsReferredPatient.prototype.emergencyContact = undefined;

/**
 * @member {String} emergencyContactPhoneNumber
 */
ReferredPatientsReferredPatient.prototype.emergencyContactPhoneNumber = undefined;

/**
 * @member {String} healthSystemContact
 */
ReferredPatientsReferredPatient.prototype.healthSystemContact = undefined;

/**
 * @member {Boolean} deceased
 */
ReferredPatientsReferredPatient.prototype.deceased = undefined;

/**
 * @member {String} cancellationReason
 */
ReferredPatientsReferredPatient.prototype.cancellationReason = undefined;

/**
 * @member {Array.<String>} clearances
 */
ReferredPatientsReferredPatient.prototype.clearances = undefined;

/**
 * @member {Array.<String>} comorbidities
 */
ReferredPatientsReferredPatient.prototype.comorbidities = undefined;

/**
 * @member {Boolean} smoking
 */
ReferredPatientsReferredPatient.prototype.smoking = undefined;

/**
 * @member {Boolean} diabetes
 */
ReferredPatientsReferredPatient.prototype.diabetes = undefined;

/**
 * @member {Boolean} hypertension
 */
ReferredPatientsReferredPatient.prototype.hypertension = undefined;

/**
 * @member {Boolean} anemia
 */
ReferredPatientsReferredPatient.prototype.anemia = undefined;
